import React from 'react';
import Section1 from './sections/Section1';
import DocumentsRequired from './sections/DocumentsRequired';

const Documents = ({ setStatus }) => {
  return (
    <>
      <Section1
        subTitle='step 1'
        title='Documents Required'
        message1='Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil in tenetur ipsa'
        message2='tempore? Accusantium, voluptatem. Quasi perferendis, nostrum reprehenderit sed'
      />
      <DocumentsRequired setStatus={setStatus} />
    </>
  );
};

export default Documents;
